import { months } from './Constants';

export const HISTORY_SAVED_LOCATION_STORAGE_KEY = 'history-saved-location';

const dateIsValid = (date) => {
  return date instanceof Date && !Number.isNaN(date);
};

export const formatDate = (creationDate) => {
  if (!dateIsValid(creationDate)) return '';
  const month = months[creationDate.getMonth()].substring(0, 3);
  const year = creationDate.getFullYear();
  const day = creationDate.getDate();
  return `${month} ${day} ${year}`;
};

export const addZero = (num) => {
  return num < 10 ? `0${num}` : num;
};

export const todayDateFilter = (creationTime) => {
  let epochTime = '';
  if (typeof creationTime === 'number') {
    epochTime = creationTime;
  } else if (typeof creationTime === 'string') {
    epochTime = Date.parse(creationTime);
  }
  const creationDate = new Date(epochTime);
  if (!dateIsValid(creationDate)) return '';
  const todayDate = new Date(Date.now());
  const formattedCreatedDate = formatDate(creationDate);
  const formattedTodayDate = formatDate(todayDate);
  const isToday = formattedCreatedDate === formattedTodayDate;
  if (isToday) {
    return `Today ${addZero(creationDate.getHours())}:${addZero(creationDate.getMinutes())}`;
  }
  return formattedCreatedDate;
};

export const capitalizeFirstLetter = (input) => {
  return typeof input === 'string' && input.length > 0 ? input.charAt(0).toUpperCase() + input.slice(1) : input;
};
